module.exports = __webpack_public_path__ + "static/img/img_logo.png@2x.9f10ef3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_logo.png@2x.png
// module id = S2R1
// module chunks = 1